export const common = {
  type: {
    messaging: {
      title: 'Pesan',
      sms: 'SMS',
      hlr: 'HLR'
    },
    voice: {
      title: 'Komunikasi suara',
      inc_voice: 'Panggilan masuk',
      out_voice: 'Panggilan keluar',
      pbx_inc_voice: 'PBX Panggilan masuk',
      pbx_out_voice: 'PBX Panggilan keluar',
      autocaller_inc_voice: 'Panggilan masuk autoinformer',
      autocaller_out_voice: 'Panggilan keluar autoinformer',
      predictive_out_voice: 'Pemanggil Prediktif Panggilan keluar',
      predictive_inc_voice: 'Pemanggil Prediktif Panggilan masuk',
      amo_out_voice: 'Widget CRM Outgoing calls',
      amo_inc_voice: 'Widget CRM Incoming voice',
      kommo_inc_voice: 'Widget suara masuk Kommo CRM',
      kommo_out_voice: 'Widget suara keluar Kommo CRM'
    },
    number_verification: {
      title: 'Verifikasi nomor',
      sms_number_verification: 'Verifikasi melalui SMS',
      call_number_verification: 'Verifikasi panggilan keluar',
      phone_number_verification: 'Verifikasi panggilan masuk',
      voice_number_verification: 'Verifikasi panggilan masuk dengan dikte kode'
    }
  },

  info: {
    no_rates: 'Tidak ada hagra',
    billing_terms_tooltip:
      '<b>FT (Waktu Senggang)</b> - ini adalah waktu dalam detik sejak dimulainya panggilan, selama tidak dikenakan biaya.<br/><b>MC (Minimum Commitment)</b> – adalah interval penagihan awal minimum. Yaitu, waktu setelah FT berakhir, di mana uang akan didebit, meskipun panggilan lebih pendek dari waktu ini.<br/><b>CI (Commitment Interval)</b> – adalah interval penagihan utama. Artinya, interval panggilan akan dibebankan setelah FT dan MC. Jika CI=0, maka panggilan akan dikenakan biaya sesuai MC sampai akhir.'
  },

  field: {
    name: 'Nama',
    mcc: 'MCC',
    mnc: 'MNC',
    code: 'Kode',
    country: 'Negara',
    provider: 'Nama Provider',
    price: 'Harga',
    date_start: 'Berlaku dari',
    date_end: 'Berlaku hingga',
    trunk: 'Belalai',
    billing_terms: 'Persyaratan penagihan'
  }
};
